import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const TidalString = ({effect}) => { 
    let [value, setValue] = useState(effect.tidalString);

    useEffect(() => {
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [value, effect]);

    const onKeyDown = useCallback((e) => {
        if (e.key === "Enter" ){
            onEnter();
        }
    }, [value, effect]);
    const onChange = useCallback((e) => {
        setValue(e.target.value);
    }, [setValue]);

    const onEnter = useCallback(() => {
        effect.tidalString = value;
    }, [value, effect]);

    return (
        <div className="tidal-string">
          <input value={value} onChange={onChange} type="text" className="tidal-input"/>
          <div className="Enter" onClick={onEnter}>Enter</div>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TidalString);
